<template>
    <el-page class="art-detail">
        <div class="center">
            <div class="content">
                <div class="nav-list">

                </div>
                <div class="tit-con">
                    <div class="tit">{{ data.title }}</div>
                </div>

                <div class="line-box">
                    <div class="arrow"></div>
                </div>

                <div class="con" v-html="data.content">
                </div>

                <div class="close-btn">
                    <div @click="closePage()">{{ lang === 'zh' ? '关闭' : 'Close' }}</div>
                </div>

                <div class="related">
                    <div class="r-tit">{{ lang === 'zh' ? '最新文章' : 'Latest' }}</div>
                    <div class="list">
                        <template v-for="item in linkList">
                            <a style="cursor: pointer;" @click="jumpDetail(item)" target="_blank" :key="`${item.id}`">
                                <span class="point"></span>
                                <span class="tit word-wrap">
                                    {{ getTit(item.title) }}
                                </span>
                                <span>{{ createDate(item.publishTime) }}</span>
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </el-page>
</template>

<script>
export default {
    name: "ArticleDetail",
    data() {
        return {
            banner: {},
            data: {},
            linkList: []
        }
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        lang() {
            return this.$i18n.locale;
        },
    },
    methods: {
        jumpDetail(item) {
            const link = item.jumpUrl;
            if (link === 'local') {
                window.open('/news-detail/' + item.id);
            } else if (link) {
                window.open(link)
            }
        },
        createDate(date) {
            const y = date.substr(0, 4);
            const m = date.substr(4, 2);
            const d = date.substr(6);
            return `${d}/${m}/${y}`
        },
        getTit(tit) {
            if (tit.length > 66) {
                return tit.substr(0, 66) + '...';
            } else {
                return tit;
            }
        },
        getData() {
            const lang = this.lang === 'zh' ? 'china' : 'english';
            this.$http.getContentById({ id: this.id, lang }).then(data => {
                // const content = data.content || '';
                // this.data = {...data, strList: content.split('<br>')}

                this.data = { ...data };
            });
        },
        closePage() {
            window.close();
        },
        getBanner() {
            this.$http.getOnlyContent({
                itemType: '3',
                platform: 'pc',
                language: 'china',
            }).then(res => {
                this.banner = res.imageMaps['33'][0];
            });
        },
        getList() {
            this.$http.getOnlyContent({
                itemType: '3',
                pageSize: 5,
                platform: 'pc',
                language: this.lang === 'zh' ? 'china' : 'english'
            }).then(res => {
                const _ = res.crmOweContentMaps || {};
                const _301 = _['301'] || []
                const _302 = _['302'] || []
                this.linkList = [..._301, ..._302].sort((prev, next) => {
                    return next.publishTime - prev.publishTime;
                }).splice(0, 5);
            })
        }
    },
    watch: {
        "$i18n.locale": {
            immediate: true,
            handler(v) {
                this.getBanner();
                this.getList();
                this.getData();
            }
        },
    }
}
</script>

<style scoped lang="less">
.art-detail {
    // background: #f5f5f5;

    .center {
        padding: 30px 0;
        background: #fff;
    }

    .content {
        width: 80%;
        margin: 0 auto;

        .con {
            /deep/ img {
                max-width: 100%;
            }
        }
    }

    .tit-con {
        .tit {
            margin: 0 0 28px;
            text-align: center;
            font-size: 32px;
            color: #037698;
            font-weight: bold;
        }

        .sub-tit {
            color: #949494;
            font-size: 14px;
            text-align: center;
            margin-bottom: 30px;
        }
    }

    .line-box {
        height: 1px;
        background: #a0a0a0;
        position: relative;
        margin-bottom: 30px;

        .arrow {
            width: 0;
            height: 0;
            border-color: transparent;
            border-top-color: #037698;
            border-width: 10px;
            border-style: solid;
            position: absolute;
            left: calc((100% - 10px) / 2);
        }
    }

    .close-btn {
        text-align: right;
        margin: 50px 0;

        div {
            display: inline-block;
            width: 170px;
            height: 48px;
            text-align: center;
            line-height: 48px;
            background: #037698;
            color: #fff;
            cursor: pointer;
        }
    }

    .related {
        .r-tit {
            font-size: 25px;
            color: #037698;
            font-weight: bold;
            margin-bottom: 30px;
        }

        .list {
            a {
                display: flex;
                text-decoration: none;
                border-bottom: 1px solid #a0a0a0;
                align-items: center;
                padding: 10px 0;
                color: #303030;
                justify-content: space-between;

                .point {
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background: #037698;
                    margin-right: 20px;
                }

                .tit {
                    flex-grow: 1;
                }

                &:visited {
                    color: #949494;

                    .point {
                        background: #949494;
                    }
                }
            }
        }
    }
}


/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
    .art-detail {

        .content {
            width: 100%;
            padding: 0 1rem;
        }

        .tit-con {
            .tit {
                font-size: 16px;
                margin-bottom: 2rem;
            }
        }
    }
}
</style>